module.exports = __webpack_public_path__ + "img/tabToggle.0426dcbc.png";